import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { cn } from '../../utils/cn';
const Sidebar = React.forwardRef(({ className, collapsible = false, collapsed = false, width = 'w-64', ...props }, ref) => {
    return (_jsx("aside", { ref: ref, className: cn('bg-white border-r border-gray-200 transition-all duration-300 ease-in-out', width, collapsed && 'w-16', className), ...props }));
});
Sidebar.displayName = 'Sidebar';
export { Sidebar };
